module.exports = __webpack_public_path__ + "media/images/athletes/1823-ee6aa61d7a7ee1cd3185c6870e797ae3.png";